/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import AppLogo from "./AppLogo";
import { Flex, Icon, Text, View } from "@aws-amplify/ui-react";
export default function FooterNew(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="192px"
      direction="row"
      width="1440px"
      height="331px"
      justifyContent="center"
      alignItems="center"
      position="relative"
      padding="32px 25px 32px 25px"
      backgroundColor="rgba(16,38,65,1)"
      {...getOverrideProps(overrides, "FooterNew")}
      {...rest}
    >
      <Flex
        gap="28px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464410")}
      >
        <AppLogo
          display="flex"
          gap="3.025209903717041px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="4.840335845947266px 4.840335845947266px 4.840335845947266px 4.840335845947266px"
          darkMode={true}
          {...getOverrideProps(overrides, "AppLogo")}
        ></AppLogo>
        <Flex
          padding="0px 0px 0px 0px"
          width="100px"
          height="44px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          position="relative"
          {...getOverrideProps(overrides, "Item724223256")}
        >
          <Flex
            gap="12px"
            direction="row"
            width="100px"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            position="absolute"
            bottom="0px"
            left="0%"
            right="0%"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Socia")}
          >
            <Flex
              padding="0px 0px 0px 0px"
              width="44px"
              height="44px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              shrink="0"
              position="relative"
              {...getOverrideProps(overrides, "Item724223258")}
            >
              <Icon
                width="44px"
                height="44px"
                viewBox={{ minX: 0, minY: 0, width: 44, height: 44 }}
                paths={[
                  {
                    d: "M44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22Z",
                    fill: "rgba(255,255,255,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="0px"
                left="0px"
                {...getOverrideProps(overrides, "Ellipse 21")}
              ></Icon>
              <View
                width="18px"
                height="18px"
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                overflow="hidden"
                position="absolute"
                top="29.55%"
                bottom="29.55%"
                left="29.55%"
                right="29.55%"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "instagram 1")}
              ></View>
              <Icon
                width="19.06px"
                height="18px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 19.059999465942383,
                  height: 18.000999450683594,
                }}
                paths={[
                  {
                    d: "M4 2.001C3.99974 2.53143 3.78877 3.04004 3.41351 3.41492C3.03825 3.78981 2.52943 4.00027 1.999 4C1.46857 3.99974 0.959965 3.78877 0.585079 3.41351C0.210194 3.03825 -0.000264966 2.52943 2.50361e-07 1.999C0.000265467 1.46857 0.211233 0.959965 0.586494 0.585079C0.961754 0.210194 1.47057 -0.000264966 2.001 2.50361e-07C2.53143 0.000265467 3.04004 0.211233 3.41492 0.586494C3.78981 0.961754 4.00027 1.47057 4 2.001ZM4.06 5.481L0.0600002 5.481L0.0600002 18.001L4.06 18.001L4.06 5.481ZM10.38 5.481L6.4 5.481L6.4 18.001L10.34 18.001L10.34 11.431C10.34 7.771 15.11 7.431 15.11 11.431L15.11 18.001L19.06 18.001L19.06 10.071C19.06 3.901 12 4.131 10.34 7.161L10.38 5.481Z",
                    fill: "rgba(58,81,117,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="25%"
                bottom="34.09%"
                left="29.55%"
                right="27.14%"
                {...getOverrideProps(overrides, "Vector")}
              ></Icon>
            </Flex>
          </Flex>
        </Flex>
        <Text
          fontFamily="Inter"
          fontSize="18px"
          fontWeight="400"
          color="rgba(255,255,255,1)"
          lineHeight="29.434091567993164px"
          textAlign="left"
          display="block"
          direction="column"
          justifyContent="unset"
          width="674px"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Copyright © 2022 2309225 Alberta Ltd. RHEALIZE &#xA;All Rights Reserved"
          {...getOverrideProps(
            overrides,
            "Copyright \u00A9 2022 2309225 Alberta Ltd. RHEALIZE All Rights Reserved"
          )}
        ></Text>
      </Flex>
      <Flex
        gap="43px"
        direction="row"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464409")}
      >
        <Flex
          gap="8px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Item724223264")}
        >
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="700"
            color="rgba(255,255,255,1)"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="145.33px"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Overview"
            {...getOverrideProps(overrides, "Overview")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(255,255,255,1)"
            lineHeight="40px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="175px"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="For employers"
            {...getOverrideProps(overrides, "For employers")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(255,255,255,1)"
            lineHeight="40px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="175px"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="About"
            {...getOverrideProps(overrides, "About")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(255,255,255,1)"
            lineHeight="40px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="175px"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Contact"
            {...getOverrideProps(overrides, "Contact")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(255,255,255,1)"
            lineHeight="40px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="175px"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Blog"
            {...getOverrideProps(overrides, "Blog")}
          ></Text>
        </Flex>
        <Flex
          gap="8px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Item724223270")}
        >
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="700"
            color="rgba(255,255,255,1)"
            lineHeight="34px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="145.33px"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Resources"
            {...getOverrideProps(overrides, "Resources")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(255,255,255,1)"
            lineHeight="40px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="175px"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Privacy Policy"
            {...getOverrideProps(overrides, "Privacy Policy")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            color="rgba(255,255,255,1)"
            lineHeight="40px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="175px"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Terms of Use"
            {...getOverrideProps(overrides, "Terms of Use")}
          ></Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
